import crypto from "crypto"; // should have webcrypto.getRandomValues defined
import { v4 as uuidV4 } from "uuid";
import { getDomain, getVideoApiUrl } from "../../utils";

/**
 * Returns the video API URL and domain based on the given configuration and sandbox flag.
 *
 * @param {string} domainOverride - Optional domain override from Orca config prop
 * @param {boolean} isSandbox - Flag indicating whether the environment is a sandbox.
 * @returns {object} - An object containing the video API URL and domain.
 * @property {string} videoApiUrl - The URL of the video API.
 * @property {string} domain - The domain of the configuration.
 */
export const getVideoAPIAndDomain = (domainOverride, isSandbox) => {
  const videoApiUrl = getVideoApiUrl(isSandbox);

  const domain = getDomain(domainOverride);

  return { videoApiUrl, domain };
};

export const generateUniqueID = () => {
  if (typeof global.crypto !== "object") {
    global.crypto = crypto;
  }

  if (typeof global.crypto.getRandomValues !== "function") {
    global.crypto.getRandomValues = getRandomValues;
  }
  return uuidV4();
};

function getRandomValues(array) {
  return crypto.webcrypto.getRandomValues(array);
}
